import { Form, Select, type SelectProps, type FormItemProps } from "antd";

interface Props extends FormItemProps {
  inputProps?: SelectProps;
}

export default function FormItemInputSelect({ inputProps, ...rest }: Props) {
  return (
    <Form.Item {...rest} className={`${rest.className} mb-0!`}>
      <Select showSearch={{ optionFilterProp: "label" }} {...inputProps} />
    </Form.Item>
  );
}
